import { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import { api } from "./api";
import type { StudyProgress } from "./chaptersApi";

/** Like useStudyProgress, but also says when loading has finished (even if it failed), so pages can show a skeleton until then. */
export function useStudyProgressState(): { data: StudyProgress | null; loading: boolean } {
  const { tokens } = useAuth();
  const token = tokens?.accessToken ?? "";
  const [data, setData] = useState<StudyProgress | null>(null);
  const [loading, setLoading] = useState(Boolean(token));
  useEffect(() => {
    if (!token) {
      setLoading(false);
      return;
    }
    let cancelled = false;
    api.student.chapters
      .progress(token)
      .then((p) => !cancelled && setData(p))
      .catch(() => undefined)
      .finally(() => !cancelled && setLoading(false));
    return () => {
      cancelled = true;
    };
  }, [token]);
  return { data, loading };
}

/** Chapter progress per course and the last chapter read. Null while loading or when unavailable. */
export function useStudyProgress(): StudyProgress | null {
  return useStudyProgressState().data;
}
